import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  likedLodges: [],
  allLodges: [],
  deleteLodge: {
    delete: false,
    loading: false
  },
};

export const lodgeSlice = createSlice({
  name: "lodge",
  initialState,

  reducers: {
    // add a lodge detail to state
    addLodge: (state, action) => {
      const existingLikedLodge = state.likedLodges.find(
        (item) => item._id === action.payload._id
      );

      if (!existingLikedLodge) {
        state.likedLodges.push(action.payload);
      }
    },

    setAllLodges: (state, action) => {
      state.allLodges = action.payload
    },

    removeLodge: (state, action) => {
      state.likedLodges = state.likedLodges.filter(item => item._id !== action.payload)
    },
    deleteLodge: (state, action) => {
      state.deleteLodge = action.payload
    },
    removeDeleteLodge: (state) => {
      state.deleteLodge = {delete: false}
    },
    startDeleting: (state) => {
      state.deleteLodge.loading = true
    },
  },
});

export const { addLodge, removeLodge, setAllLodges, deleteLodge, removeDeleteLodge, startDeleting} = lodgeSlice.actions;
export const selectLikedLodges = (state) => state.lodge.likedLodges;
export const selectAllLodges = (state) => state.lodge.allLodges
export const selectDeleteLodge = (state) => state.lodge.deleteLodge
export default lodgeSlice.reducer;
